module.exports = __webpack_public_path__ + "img/work2022-tvcg-gesture.e6cf112a.png";